<footer>
    <div class="col-12 footer-section">
        <div class="shape-footer"></div>
        <div class="col-12 footer-top">
            <div class="container">
                <div class="col-lg-3 col-sm-6 col-12 footer-about">
                    <div class="footer-logo">
                        <a href="/"><img alt="hayti_logo.png" src="assets/images/hayti_logo.png"></a>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4 col-12 footer-links">
                    <div class="fot_links">
                        <h5>Company</h5>
                        <ul>
                            <!-- <li><a routerLink="/about-us">About Us</a></li> -->
                            <li><a routerLink="/press-media">Press &amp; Media </a></li>
                            <li><a routerLink="/contact-us">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-4 col-12 footer-links">
                    <h5>Partners</h5>
                    <ul>
                        <li><a routerLink="/publishers">Publishers</a></li>
                        <li><a routerLink="/podcasters">Podcasters</a></li>
                    </ul>
                </div>
                <div class="col-lg-3 col-sm-4 col-12 footer-links">
                    <h5>Terms and Policies</h5>
                    <ul>
                        <li><a  routerLink="/publisher-terms">Terms for Publishers</a></li>
                        <li><a  routerLink="/podcaster-terms">Terms for Podcasters</a></li>
                    </ul>
                </div>
                <div class="col-lg-2 col-sm-6 col-12  footer-info">
                    <h5>Stay Connected</h5>
                    <div class="footer-social">
                        <ul>
                            <li><a href="https://www.facebook.com/haytiapp"><i class="fa fa-facebook"
                                        aria-hidden="true"></i></a></li>
                            <li><a href="https://www.instagram.com/haytiapp/"><i class="fa fa-instagram"
                                        aria-hidden="true"></i></a></li>
                            <li><a href="https://twitter.com/haytiapp"><i class="fa fa-twitter"
                                        aria-hidden="true"></i></a></li>
                        </ul>
                    </div>
                    <!-------------------------05-09-2022 EXTRA lOGO---------------->
                    <div class="B_logo">
                        <ul>
                            <li><a href="https://blackownedmedia.org/"><img src="assets/images/BOMESI-badge_WH1.png" alt="BOMESI-badge_WH1.png"></a></li>
                        </ul>
                    </div>
                    <!-------------------------END EXTRA lOGO---------------->
                </div>
            </div>
        </div>
        <div class="col-12 footer-bottom">
            <div class="container">
                <div class="col-12 d-flex">
                    <p>© {{year}} Hayti LLC. All rights reserved.</p>
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy.</a></li>
                        <li><a routerLink="/terms-of-service">Terms of Use.</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

</footer>